import React, { useEffect, useState } from "react";
import moment from "moment";
import AvancesService from "../../services/AvancesService";

// Lists every Avance loaded for a destajo (its own and its subdestajos'),
// newest first, showing who registered each and how much.
const DestajoHistorial = ({ idProyecto, idDestajo, concepto, progreso }) => {
  const [avances, setAvances] = useState(null);

  useEffect(() => {
    fetchAvances();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idProyecto, idDestajo]);

  const fetchAvances = () => {
    AvancesService.getAvancesDestajo(idProyecto, idDestajo).then((res) => {
      setAvances(res.data.avances);
    });
  };

  const cantidadConcepto = concepto ? Number(concepto.cantidad) : NaN;
  const unidad = concepto && concepto.unidad ? concepto.unidad : "";
  const fraction = parseFloat(progreso) || 0;
  const totalPorcentual = Math.round(fraction * 100);
  const totalAmount =
    !isNaN(cantidadConcepto) && cantidadConcepto > 0
      ? Math.round(fraction * cantidadConcepto * 100) / 100
      : null;

  const renderCantidad = (avance) => {
    const cantidad = parseFloat(avance.cantidad);
    const signo = cantidad > 0 ? "+" : "";
    if (avance.por_cantidad) {
      return `${signo}${cantidad}${unidad ? ` ${unidad}` : ""}`;
    }
    return `${signo}${cantidad}%`;
  };

  const renderAvances = () => {
    if (!Array.isArray(avances)) {
      return (
        <div className="d-flex justify-content-center py-4">
          <div className="spinner-border text-secondary" />
        </div>
      );
    }
    if (avances.length === 0) {
      return (
        <p className="text-muted text-center py-4">
          Aún no se han registrado avances.
        </p>
      );
    }
    return avances.map((avance) => (
      <div
        key={avance.idAvance}
        className="d-flex align-items-center border-bottom py-2 text-start"
      >
        <span
          className="me-3 flex-shrink-0 fw-bold text-primary"
          style={{ fontSize: "1.25rem", minWidth: 70 }}
        >
          {renderCantidad(avance)}
        </span>
        <div className="flex-grow-1" style={{ minWidth: 0 }}>
          <div className="d-flex align-items-center" style={{ minWidth: 0 }}>
            <i className="fa fa-user-circle me-2 text-secondary flex-shrink-0" />
            {avance.rol ? (
              <span className="badge bg-dark text-capitalize me-2 flex-shrink-0">
                {avance.rol}
              </span>
            ) : null}
            <span
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                minWidth: 0,
              }}
            >
              {avance.usuario || "Usuario desconocido"}
            </span>
          </div>
          <div className="small text-muted">
            {moment(avance.createdAt).format("DD MMM YYYY, HH:mm")}
            {avance.subdestajo ? ` · ${avance.subdestajo}` : ""}
          </div>
        </div>
      </div>
    ));
  };

  return (
    <div className="text-start" style={{ userSelect: "text" }}>
      <h3 className="h5 mb-2 text-start">Historial de avances</h3>
      <div className="mb-3">
        <div className="text-muted">Total actual:</div>
        {totalAmount != null && (
          <div style={{ fontSize: "1.5rem" }}>
            {totalAmount} {unidad}
          </div>
        )}
        <div className="position-relative mt-1" style={{ height: 30 }}>
          <div className="progress h-100">
            <div
              className="progress-bar"
              role="progressbar"
              style={{
                width: `${totalPorcentual}%`,
                height: "100%",
                backgroundColor: "#89d405",
              }}
              aria-valuenow={totalPorcentual}
              aria-valuemin="0"
              aria-valuemax="100"
            />
          </div>
          <div
            className="position-absolute top-50 start-50 translate-middle text-dark"
            style={{ fontSize: "1.1rem" }}
          >
            {totalPorcentual}%
          </div>
        </div>
      </div>
      <div style={{ maxHeight: "calc(100vh - 200px)", overflowY: "auto" }}>
        {renderAvances()}
      </div>
    </div>
  );
};

export default DestajoHistorial;
